import React from 'react';
import Routes from '../../../shared/constants/CargoRoutes';
import {pageRoutes} from 'containers';

export const cargoPagesConfig = [
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/rate-class-old/:formid',
        component: React.lazy(() => import('./RateClass')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/rate-class-new/:formid',
        component: React.lazy(() => import('./RateClass2')),
      },
    ],
  },

  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: '/cargo/pricing/:formid',
  //       component: React.lazy(() => import('./Pricing')),
  //     },
  //   ],
  // },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/CreateAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/EditAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/EditDraftAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/EditTemporaryAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/FilesEditAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/CCAAWB',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/awbCalc',
        component: React.lazy(() => import('./AWBWizard')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/test/',
        component: React.lazy(() => import('./Test')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.AIR_PORT,
        component: React.lazy(() => import('./Airport')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.ROUTE,
        component: React.lazy(() => import('./Route')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.ORIGIN_DESTINATION,
        component: React.lazy(() => import('./OriginDestination')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.AJANS, //issuer awb
        component: React.lazy(() => import('./Ajans')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.USERS, //issuer awb
        component: React.lazy(() => import('./Users')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.ROLES, //issuer awb
        component: React.lazy(() => import('./Roles')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.LEVELS, //issuer awb
        component: React.lazy(() => import('./Levels')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.HANDLING_SERVICES_COST,
        component: React.lazy(() => import('./HandlingServiceCost')),

        // path: Routes.CARGO_COST,
        // component: React.lazy(() => import('./CargoCost')),
      },
    ],
  },

  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/AWB_old',
        component: React.lazy(() => import('./AWB_old')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: '/cargo/CCA',
        component: React.lazy(() => import('./CCA')),
      },
    ],
  },
  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.ISSUED_AWB,
  //       component: React.lazy(() => import('./AWB')),
  //     },
  //   ],
  // },
  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.RESERVED_AWB,
  //       component: React.lazy(() => import('./AWB')),
  //     },
  //   ],
  // },
  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.DRAFT_AWB_LIST,
  //       component: React.lazy(() => import('./AWB')),
  //     },
  //   ],
  // },
  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.TEMPORARY_AWB_LIST,
  //       component: React.lazy(() => import('./AWB')),
  //     },
  //   ],
  // },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.RECEIPT_HISTORY,
        component: React.lazy(() => import('./ReceiptHistory')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.SUBMIT_RECEIPT,
        component: React.lazy(() => import('./AWB')),
      },
    ],
  },

  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.AWB_LIST,
        component: React.lazy(() => import('./AWB/AWB_List')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.AWB_ISSUER,
        component: React.lazy(() => import('./AWB')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.CARGO_COST,
        component: React.lazy(() => import('./CargoCostNew')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.SUBMIT_RECIEPT,
        component: React.lazy(() => import('./SubmitReciept')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.DASHBOARD,
        component: React.lazy(() => import('./Dashboards')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.APPROVED_RECIEPT,
        component: React.lazy(() => import('./ApprovedReciept')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.REFUND,
        component: React.lazy(() => import('./Refund')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.TRANSACTIONS,
        component: React.lazy(() => import('./Transactions')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: Routes.RETURN_MONEY,
        component: React.lazy(() => import('./ReturnMoney')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.REPORTS,
        component: React.lazy(() => import('./Report')),
      },
    ],
  },

  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.RESERVED_AWB,
  //       component: React.lazy(() => import('./AwbList')),
  //     },
  //   ],
  // },

  // {
  //   auth: ['user'],
  //   exact: true,
  //   routes: [
  //     {
  //       path: Routes.AWB_LISTS,
  //       component: React.lazy(() => import('./AwbList')),
  //     },
  //   ],
  // },
];
